export default function LabelText({ text }: { text: string }) {
  return <div className="mb-2.5 text-sm text-[#B7B7B7]">{text}</div>;
}
